(function () {
  function injectOrbeOverride() {
    if (document.querySelector('#hurley-orbe-overrides')) return;
    const style = document.createElement('style');
    style.id = 'hurley-orbe-overrides';
    style.textContent = [
      '.md-modal__backdrop { display: none !important; }',
      '.md-modal__bodyContent__helperText p { font-size: var(--font-size-xs) !important; }'
    ].join(' ');
    document.body.appendChild(style);
  }

  function applyPandectesOverride(shadowRoot) {
    if (shadowRoot.querySelector('#hurley-cmp-overrides')) return;
    const style = document.createElement('style');
    style.id = 'hurley-cmp-overrides';
    style.textContent = 'dialog::backdrop { display: none !important; }';
    shadowRoot.appendChild(style);
  }

  function watchShadowRoot(shadowRoot) {
    applyPandectesOverride(shadowRoot);
    new MutationObserver(function () {
      applyPandectesOverride(shadowRoot);
    }).observe(shadowRoot, { childList: true });
  }

  function injectPandectesOverride(el) {
    if (!el || !el.shadowRoot) return false;
    watchShadowRoot(el.shadowRoot);
    return true;
  }

  function init() {
    injectOrbeOverride();

    const pandectesCmp = document.querySelector('pandectes-cmp');
    if (!injectPandectesOverride(pandectesCmp)) {
      const observer = new MutationObserver(function () {
        const el = document.querySelector('pandectes-cmp');
        if (injectPandectesOverride(el)) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
